<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">PO Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="po_date_from"/> ~ <CustomDatePicker v-model="po_date_to"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendor_code" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<em class="lt_text">Country</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :width="70" :showDesc="false" :codes="countries" v-model="country" />
				</span>

				<span class="int_type mgr_15">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>

				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="true" /> </span>

				<span class="int_type sm_int">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="2%"></th>
					<th width="5%">
						<a href="javascript:;" @click="sort('po_dn')">PO No{{ sortMark('po_dn') }}</a>
					</th>
					<th width="1.5%">T</th>
					<th width="5%">
						<a href="javascript:;" @click="sort('po_date')">PO Date{{ sortMark('po_date') }}</a>
					</th>
					<th v-if="user.company_id == 'jc'" width="5%">Purchaser</th>
					<th width="5%">ESD</th>
					<th width="5%">ETA Date</th>
					<th width="6%">Vendor Code</th>
					<th v-if="user.company_id != 'newjigu'" width="15%">Vendor Name</th>
					<th v-if="user.company_id != 'newjigu'" width="5%">Pay Term</th>
					<th v-if="user.company_id != 'newjigu'" width="10%">Pay Type</th>
					<th v-if="user.company_id != 'newjigu'" idth="12%">Trade Term</th>
					<th v-if="user.company_id == 'newjigu'" idth="35%">{{ headers.class }} Code</th>
					<th width="6%">Delivery Type</th>
					<th width="4%">PO Quantity</th>
					<th width="5%">PO Amount</th>
					<th>Description</th>
					<th width="3%">Shipped</th>
					<th width="4%">Closed</th>
					<th width="2%">Hold</th>
					<!-- <th width="5%">Bill To Code</th>
					<th width="5%">Bill To Name</th>
					<th width="5%">Sales Group</th>
					<th width="3%">S/O Amt.</th>
					<th width="5%">S/O Entry</th>
					<th width="15%">Remark</th> -->
				</tr>
			</thead>
			<tbody>
				<tr v-for="purchase in purchases" v-bind:key="purchase.po_no">
					<td class="al_center">
						<input type="radio" v-model="selected_po_no" :value="purchase.po_no" />
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectPurchase(purchase)">{{ purchase.po_dn }}</a> <small v-if="user.company_id == 'hairplus'">{{ purchase.price_basis == 'FOB' ? 'FOB' : 'COST' }}</small>
					</td>
					<td class="al_center" :title="purchase.po_type == 'N' ? 'New Order' : purchase.po_type == 'B' ? 'Back Order' : ''">{{ purchase.po_type }}</td>
					<td class="al_left">{{ purchase.po_date }}</td>
					<td v-if="user.company_id == 'jc'" class="al_left truncate">{{ purchase.purchaser_name }}</td>
					<td class="al_left">{{ purchase.estimated_ship_date }}</td>
					<td class="al_left">{{ purchase.eta_date }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(purchase.vendor_code)">{{ purchase.vendor_code }}</a>
					</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(purchase.vendor_code)">{{ purchase.vendor_name }}</a>
					</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ purchase.payment_term_name }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ purchase.payment_type_name }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ purchase.trade_term_name }}</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate">{{ purchase.classes }}</td>
					<td class="al_left">{{ purchase.po_delivery_type_name }}</td>
					<td class="al_right">{{ purchase.total_quantity | commaSeparated }}</td>
					<td class="al_right">{{ purchase.total_amount | toCurrency }}</td>
					<td class="al_left truncate">{{ purchase.description }}</td>
					<td class="al_left">
						<font color="blue">{{ purchase.total_shipped_quantity > 0 ? (purchase.total_quantity == purchase.total_shipped_quantity ? 'All' : 'Partially') : '' }}</font>
					</td>
					<td class="al_center">{{ purchase.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td>
					<td class="al_center">{{ purchase.po_hold_type_code }}</td>
					<!-- <td class="al_center">{{ purchase.closed_yn == 'Y' ? '&#10003;' : '' }}</td> -->
					<!-- <td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_name }}</a>
					</td>
					<td class="al_left">{{ invoice.sales_group_name }}</td>
					<td class="al_right" v-if="invoice.status_code == 'I'">{{ invoice.total_shipped_amount | toCurrency }}</td>
					<td class="al_right" v-else>{{ invoice.total_amount | toCurrency }}</td>
					<td class="al_left truncate">{{ invoice.crt_name }}</td>
					<td class="al_left">{{ invoice.remark }}</td> -->
				</tr>
				<!-- <tr>
					<td colspan="9" class="al_right"><font color="red">Total</font></td>

					<td class="al_right">
						<font color="red">{{ total_amount_sum | toCurrency }}</font>
					</td>
					<td></td>
					<td></td>
				</tr> -->
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="excelSBM()">SBM Excel</a>
			<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt fl_l mgr_15" @click="sheetSBM()">SBM Sheet</a>
			<ul>
				<li class="mgr_15"><PageSizeSelect v-model="page_size" @input="search()" /></li>
				<li v-if="selected_po_no" class="mgr_10"><a href="javascript:void(0);" v-on:click="excel">Excel Export of Selected Purchase Items(s)</a></li>
				<li v-if="modifiable"><router-link :to="{ name: 'purchaseDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath } }">Add</router-link></li>
			</ul>
		</div>

		<table class="list_tbl mgb_0 add_top_line" v-show="false" id="exportTable">
			<thead>
				<tr>
					<th width="2%">No</th>
					<th width="10%">Class</th>
					<th>Name</th>
					<th width="7%">Color</th>
					<th width="6%">Price</th>
					<th width="5%">Qty</th>
					<th width="7%">Amount</th>
					<th width="5%">Shipped Qty</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in excelItems" v-bind:key="item.po_item_no">
					<td class="al_left">{{ index + 1 }}</td>
					<td class="al_left">{{ item.class_code }}</td>
					<td class="al_left">{{ item.name }}</td>
					<td class="al_left">{{ item.color_code }}</td>
					<td class="al_right">{{ item.unit_price }}</td>
					<td class="al_right">{{ item.quantity }}</td>
					<td class="al_right">{{ item.amount }}</td>
					<td class="al_right">{{ item.shipped_quantity }}</td>
				</tr>
			</tbody>
		</table>

		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { daysAgo, today } from '@/utils/date';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';
import { sumColumn } from '@/utils/sheetCopy';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectPurchaseList, apiSelectPurchase } from '@/api/purchase/purchase.js';
import XLSX from 'xlsx-js-style';

export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			list_count: 0,

			sort_key: null,
			sort_direction: 'ASC',

			po_date_from: daysAgo(30),
			po_date_to: today(),
			vendor_code: null,
			country: '',
			countries: [],
			//closed_yn: 'A',
			closed_yn: 'N',
			keyword: null,
			itemClass: null,

			purchases: [],

			excelItems: [],

			modalName: '',
			showModal: false,

			selected_po_no: null,

			// #3312 마지막 성공 검색 조건(정렬 포함, paging 제외)과 Sheet 팝업
			sheet_param: null,
			sheet_popup: null,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		PartnerSelect,
		ItemClassSelect,
		PageSizeSelect,
		CodeSelect,
		SheetCopyPopup,
	},
	methods: {
		// #3312 현재 입력값의 검색 조건(정렬 포함, paging 제외). 목록 조회·SBM Excel·검색 스냅샷이 같은 조건을 쓴다.
		searchCondition() {
			return {
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				po_date_from: this.po_date_from,
				po_date_to: this.po_date_to,
				vendor_code: this.vendor_code,
				country: this.country,
				closed_yn: this.closed_yn,
				keyword: this.keyword,
				class_code: this.itemClass,
			};
		},
		// #3312 SBM Excel 과 SBM Sheet 가 같은 전체(paging 없음) 조회 파라미터를 쓴다.
		sbmParam(condition) {
			return { paging_yn: 'N', ...condition, from_purchase_main: true };
		},
		// #3312 SBM Excel 과 SBM Sheet 가 같은 11열 정의를 쓴다.
		sbmHeader() {
			return [
				{ key: 'po_dn', name: 'P/O #', width: 13, dataType: defaultDataType.string },
				...(this.user.company_id == 'hairplus' ? [{ key: 'price_basis', name: 'Price basis', width: 15, dataType: defaultDataType.string }] : []),
				{ key: 'po_date', name: 'PO Date', width: 14, dataType: defaultDataType.string },
				{ key: '', name: 'FOB', width: 12, dataType: defaultDataType.string },
				{ key: 'eta_date', name: 'Req. Date', width: 14, dataType: defaultDataType.string },
				{ key: 'description', name: 'Memo', width: 25, dataType: defaultDataType.string },
				{ key: 'vendor_name', name: 'Vendor Name', width: 25, dataType: defaultDataType.string },
				{ key: 'po_delivery_type_name', name: 'Ship Via', width: 15, dataType: defaultDataType.string },
				{ key: 'total_amount', name: 'Order Total', width: 10, dataType: defaultDataType.currency },
				{ key: 'vendor_telephone', name: 'Tel', width: 15, dataType: defaultDataType.string },
				{ key: 'vendor_owner_name', name: 'Contact 1', width: 17, dataType: defaultDataType.string },
				{ key: 'remark', name: 'Remark', width: 20, dataType: defaultDataType.string },
			];
		},
		async excelSBM() {
			const { data } = await apiSelectPurchaseList(this.sbmParam(this.searchCondition()));

			const sbmItems = data.purchaseList;
			//console.log(sbmItems);

			exportDataExcel(sbmItems, this.sbmHeader(), 'PurchaseOrderSBM');
		},
		// #3312 SBM 양식 Sheet: 마지막 성공 검색 조건으로 전체 조회해 빈 열 1개 + SBM 11열, 헤더 아래 합계 행(P/O # 'ALL ()', Order Total 합)을 클립보드 복사 팝업으로 연다.
		async sheetSBM() {
			if (!this.sheet_param) {
				this.$toast.error('Please search first');
				return false;
			}
			const { data } = await apiSelectPurchaseList(this.sbmParam(this.sheet_param));
			const rows = data.purchaseList || [];
			if (rows.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return false;
			}
			this.sheet_popup = {
				title: 'Purchase Order (SBM Sheet)',
				headers: this.sbmHeader(),
				rows,
				options: { leading_blank: true, total_row: { po_dn: 'ALL ()', total_amount: sumColumn(rows, 'total_amount') } },
			};
		},
		async excel() {
			//console.log(this.selected_sh_no);

			const { data } = await apiSelectPurchase({
				po_no: this.selected_po_no,
			});

			this.excelItems = data.purchaseItemList;
			//console.log(this.excelItems);
			this.$nextTick(() => {
				var elt = document.getElementById('exportTable');
				var wb = XLSX.utils.table_to_book(elt, { raw: false });
				return XLSX.writeFile(wb, 'Purchase_ItemList_' + data.purchase.po_dn + '.xlsx', { cellDates: true });
			});
		},
		selectPurchase(purchase) {
			this.$router.push({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.uri, po_no: purchase.po_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectPurchases(pageNo);
		},
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		selectPartner() {
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			this.po_date_from = this.user.company_id == 'he' ? daysAgo(365) : daysAgo(30);
			this.po_date_to = today();
			this.closed_yn = 'A';
			this.vendor_code = null;
			this.keyword = null;
			this.itemClass = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectPurchases();
			//console.log(sort_key);
		},
		async search() {
			await this.selectPurchases();
			if (this.purchases.length == 1 && this.keyword) this.$router.push({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.uri, po_no: this.purchases[0].po_no } });
		},
		async selectPurchases(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			// #3312 조회에 보낸 조건을 그대로 스냅샷으로 남겨 SBM Sheet 가 화면 결과와 같은 조건으로 전체 조회한다.
			const condition = this.searchCondition();
			const { data } = await apiSelectPurchaseList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				...condition,

				from_purchase_main: true,
			});

			//console.log(data);

			this.sheet_param = condition;
			this.purchases = data.purchaseList;
			//console.log(this.purchases);
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/purchase/po_main?page_no=' + this.page_no;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.po_date_from) uri += '&po_date_from=' + this.po_date_from;
			if (this.po_date_to) uri += '&po_date_to=' + this.po_date_to;
			if (this.vendor_code) uri += '&vendor_code=' + this.vendor_code;
			if (this.itemClass) uri += '&itemClass=' + this.itemClass;
			if (this.country) uri += '&country=' + this.country;

			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			const { data } = await apiIndex();
			//this.salesGroups = data.salesGroupList;
			//this.states = data.stateList;
			this.countries = data.countryList;
			this.countries.push({ code: 'NON-US', name: 'NON US' });
		},
		async init() {
			await this.index();

			if (this.user.company_id == 'he') {
				//this.sort_key = 'po_dn';
				this.po_date_from = daysAgo(365);
			}

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.po_date_from) this.po_date_from = this.$route.query.po_date_from;
			if (this.$route.query.po_date_to) this.po_date_to = this.$route.query.po_date_to;
			if (this.$route.query.vendor_code) this.vendor_code = this.$route.query.vendor_code;
			if (this.$route.query.itemClass) this.itemClass = this.$route.query.itemClass;
			if (this.$route.query.country) this.country = this.$route.query.country;
			this.page_size = this.$store.getters['getDefaultPageSize'];

			await this.selectPurchases(this.$route.query.page_no);
		},
	},
	created() {
		//this.$store.sideIndex = 2;
		this.$store.commit('setSideIndex', 2);
		//this.$store.selectedMenu = 'nav_li_5';
		this.$store.commit('setSelectedMenu', 'nav_li_po_main');
		this.$store.commit('setSubTitle', 'Purchase -> Purchase Order');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
